import React from "react";
import BusForm from "./BusForm";
import ListProduct from "../../Hotel/HotelSearch/HotelSearchMobile/ListProduct";
import OfferSection from "../../Flight/FlightSearchMobile/OfferSection";
import BusTopSearch from "../BusTopSearch";
import MobileApp from "../../Flight/FlightSearchMobile/MobileApp";
import Advantage from "../../Home/Home/Advantage";
import AboutBus from "../AboutBus";

const BusMain = () => {
  return (
    <div id="hotelSearch" className="hotelsearchmobile">
      <ListProduct />
      <BusForm />
      <OfferSection />
      <BusTopSearch />
      <Advantage />
      {/* <MobileApp
        backgroundImage="https://www.keralatourism.org/images/caravan-tourism/book-trip/large/gokulam-caravan/02.webp"
        title="Download Our Mobile App"
        description="Book your bus ticket with huge discounts. Refer friends and earn generous bonuses from their bookings"
      /> */}
      <AboutBus />
    </div>
  );
};

export default BusMain;
